import { SurveyIntroductionContentComponent } from './components/survey_intro_content/survey_intro_content';
import { SurveyQuestionContentComponent } from './components/survey_question_content/survey_question_content';
import { SurveyQuestionFooterComponent } from './components/survey_question_footer/survey_question_footer';
import { SurveySummaryContentComponent } from './components/survey_summary_content/survey_summary_content';
import { SurveyPriorityFeedQuery } from './queries/survey_priority_feed_query';
import { SurveyQuery } from './queries/survey_query';
import { SurveyQuestionQuery } from './queries/survey_question_query';
import { SurveyRoutes } from './survey_routes';
import { SurveyQuestionController } from './views/survey_question/survey_question_controller';
import { SurveyIntroductionController } from './views/survey_introduction/survey_introduction_controller';
import { SurveySummaryController } from './views/survey_summary/survey_summary_controller';

angular
  .module('capability-ng-survey', [])
  .service('ngSurveyPriorityFeedQuery', SurveyPriorityFeedQuery)
  .service('ngSurveyQuery', SurveyQuery)
  .service('ngSurveyQuestionQuery', SurveyQuestionQuery)
  .controller('SurveyQuestionController', SurveyQuestionController)
  .controller('SurveyIntroductionController', SurveyIntroductionController)
  .controller('SurveySummaryController', SurveySummaryController)
  .component('surveyQuestionFooter', new SurveyQuestionFooterComponent())
  .component('surveyIntroductionContent', new SurveyIntroductionContentComponent())
  .component('surveyQuestionContent', new SurveyQuestionContentComponent())
  .component('surveySummaryContent', new SurveySummaryContentComponent())
  .config(SurveyRoutes);

import './core';

export * from './queries/survey_priority_feed_query';
export * from './queries/survey_query';
export * from './queries/survey_question_query';

export default 'capability-ng-survey';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-survey/src/main.ts